import { Component, Input } from '@angular/core';
import { IDetailKeyValue } from 'src/app/models/singlePageComponents';

@Component({
  selector: 'app-detail-keyvalue',
  templateUrl: './detail-keyvalue.component.html',
  styleUrls: ['./detail-keyvalue.component.scss'],
})
export class DetailKeyValueComponent {
  @Input() public isInAddOrEditMode: boolean;
  @Input() public input: IDetailKeyValue;
  @Input() public readonly = false;
  @Input() public placeholder = '';
}
